import { ActionMenu } from "layouts/common/buttons";
import { TextLink } from "layouts/common/buttons";
import MDTypography from "ui/MDTypography";

export default function data(meetings, handleDelete,) {

  const rows = () => {
    return meetings?.map(meeting => {
      var { meetingdata } = meeting;
      console.log("meetings", meeting);
      return {
        title: (
          <TextLink
            link={`/attendance/${meeting.id}/detail`}
            text={meeting.title}
          />
        ),
        venue: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.venue || "N/A"}
          </MDTypography>),
        totalKarkuns: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.summary?.totalKarkuns || "N/A"}
          </MDTypography>),
        presentKarkuns: (
          <MDTypography variant="caption" fontWeight="medium">
            {meeting.summary?.presentKarkuns || "N/A"}
          </MDTypography>),
        dropdown: (
          <ActionMenu
            entity={meeting}
            basePath="attendance"
            onDelete={() => handleDelete(meeting.id)}
          />
        ),
      }
    })
  }

  return {
    columns: [
      { Header: "Title", accessor: "title", align: "left" },
      { Header: "Venue", accessor: "venue", align: "left" },
      { Header: "Total Karkuns", accessor: "totalKarkuns", align: "left" },
      { Header: "Present Karkuns", accessor: "presentKarkuns", align: "left" },
      { accessor: "dropdown", align: "right" },
    ],
    rows: rows()
  };
}
